import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { znsAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    
    loadStatistics();
  }, []);

  const loadStatistics = async () => {
    try {
      const response = await znsAPI.getStatistics();
      if (response.data.success) {
        setStatistics(response.data.data);
      }
    } catch (error) {
      console.error('Load statistics error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.info('Đã đăng xuất');
    navigate('/login');
  };

  if (loading) {
    return <div className="loading">Đang tải...</div>;
  }

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src="/logo-nagen.png" alt="NAGEN" className="sidebar-logo" />
          <h3>ZNS System</h3>
        </div>

        <nav className="sidebar-nav">
          <a href="/dashboard" className="nav-item active">
            <span className="icon">📊</span>
            Dashboard
          </a>
          <a href="/send-zns" className="nav-item">
            <span className="icon">📤</span>
            Gửi ZNS đơn lẻ
          </a>
          <a href="/send-bulk-zns" className="nav-item">
            <span className="icon">📨</span>
            Gửi hàng loạt
          </a>
          <a href="/templates" className="nav-item">
            <span className="icon">📝</span>
            Quản lý Template
          </a>
          <a href="/history" className="nav-item">
            <span className="icon">📜</span>
            Lịch sử gửi
          </a>
          {user?.role === 'admin' && (
            <a href="/users" className="nav-item">
              <span className="icon">👥</span>
              Quản lý User
            </a>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-avatar">{user?.full_name?.charAt(0) || user?.username?.charAt(0)}</span>
            <div>
              <div className="user-name">{user?.full_name || user?.username}</div>
              <div className="user-role">{user?.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="btn-logout">Đăng xuất</button>
        </div>
      </aside>

      <main className="main-content">
        <div className="page-header">
          <h1>Dashboard</h1>
          <p>Tổng quan hệ thống ZNS</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon blue">📨</div>
            <div className="stat-info">
              <h3>{statistics?.total || 0}</h3>
              <p>Tổng tin đã gửi</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon green">✅</div>
            <div className="stat-info">
              <h3>{statistics?.by_status?.find(s => s.status === 'sent')?.count || 0}</h3>
              <p>Gửi thành công</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon red">❌</div>
            <div className="stat-info">
              <h3>{statistics?.by_status?.find(s => s.status === 'failed')?.count || 0}</h3>
              <p>Gửi thất bại</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon yellow">⏳</div>
            <div className="stat-info">
              <h3>{statistics?.by_status?.find(s => s.status === 'pending')?.count || 0}</h3>
              <p>Đang xử lý</p>
            </div>
          </div>
        </div>

        <div className="content-grid">
          <div className="card">
            <h3>Template phổ biến</h3>
            <div className="template-list">
              {statistics?.by_template?.length > 0 ? (
                statistics.by_template.map((item, index) => (
                  <div key={index} className="template-item">
                    <span className="template-name">{item.template_name}</span>
                    <span className="template-count">{item.count} tin</span>
                  </div>
                ))
              ) : (
                <p className="empty-state">Chưa có dữ liệu</p>
              )}
            </div>
          </div>

          <div className="card">
            <h3>Hoạt động gần đây (7 ngày)</h3>
            <div className="activity-chart">
              {statistics?.daily?.length > 0 ? (
                statistics.daily.map((item, index) => (
                  <div key={index} className="activity-item">
                    <span className="activity-date">{new Date(item.date).toLocaleDateString('vi-VN')}</span>
                    <div className="activity-bar">
                      <div 
                        className="bar-sent" 
                        style={{width: `${(item.sent_count / item.count) * 100}%`}}
                      />
                    </div>
                    <span className="activity-count">{item.count} tin</span>
                  </div>
                ))
              ) : (
                <p className="empty-state">Chưa có dữ liệu</p>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
